module.exports = __webpack_public_path__ + "img/eow.74fcff0c.jpg";